import { post } from '@/utils/examMan/request'

/**
 * 章节列表
 * @param data
 * @returns {*}
 */
export function fetchList(data) {
  return post('/api/learn/api/repo/chapter/list', data)
}
